/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { CompaniesResponse } from '@/client/models';
// @ts-ignore
import type { CoverageCoverageNetworksGet200Response } from '@/client/models';
// @ts-ignore
import type { CoverageCoverageRoutesGet200Response } from '@/client/models';
// @ts-ignore
import type { CoverageCoverageStopPointsGet200Response } from '@/client/models';
// @ts-ignore
import type { LinesResponse } from '@/client/models';
// @ts-ignore
import type { PlacesResponse } from '@/client/models';
// @ts-ignore
import type { StopAreasResponse } from '@/client/models';
// @ts-ignore
import type { VehicleJourneysResponse } from '@/client/models';
/**
 * PublicTransportObjectsApi - axios parameter creator
 */
export const PublicTransportObjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all companies
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCompaniesGet: async (coverage: string, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageCompaniesGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/companies`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all lines
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageLinesGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageLinesGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/lines`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all networks
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageNetworksGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageNetworksGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/networks`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Autocomplete on Public Transport objects
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} q Search query
         * @param {number} [count] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePtObjectsGet: async (coverage: string, q: string, count?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoveragePtObjectsGet', 'coverage', coverage)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('coverageCoveragePtObjectsGet', 'q', q)
            const localVarPath = `/coverage/{coverage}/pt_objects`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all routes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageRoutesGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageRoutesGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/routes`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all stop areas
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopAreasGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageStopAreasGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/stop_areas`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all stop points
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopPointsGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageStopPointsGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/stop_points`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of vehicle journeys. Can be filtered by headsign, since/until dates, and data_freshness.
         * @summary List vehicle journeys
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} [headsign] Filter by headsign
         * @param {string} [since] Filter journeys since this datetime (YYYYMMDDTHHmmss)
         * @param {string} [until] Filter journeys until this datetime (YYYYMMDDTHHmmss)
         * @param {CoverageCoverageVehicleJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness filter
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageVehicleJourneysGet: async (coverage: string, headsign?: string, since?: string, until?: string, dataFreshness?: CoverageCoverageVehicleJourneysGetDataFreshnessEnum, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageVehicleJourneysGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/vehicle_journeys`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (headsign !== undefined) {
                localVarQueryParameter['headsign'] = headsign;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = until;
            }

            if (dataFreshness !== undefined) {
                localVarQueryParameter['data_freshness'] = dataFreshness;
            }

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get vehicle journey details
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Vehicle journey ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageVehicleJourneysIdGet: async (coverage: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageVehicleJourneysIdGet', 'coverage', coverage)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coverageCoverageVehicleJourneysIdGet', 'id', id)
            const localVarPath = `/coverage/{coverage}/vehicle_journeys/{id}`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicTransportObjectsApi - functional programming interface
 */
export const PublicTransportObjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicTransportObjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all companies
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageCompaniesGet(coverage: string, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompaniesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageCompaniesGet(coverage, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoverageCompaniesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all lines
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageLinesGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageLinesGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoverageLinesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all networks
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageNetworksGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageNetworksGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageNetworksGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoverageNetworksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Autocomplete on Public Transport objects
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} q Search query
         * @param {number} [count] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoveragePtObjectsGet(coverage: string, q: string, count?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoveragePtObjectsGet(coverage, q, count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoveragePtObjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all routes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageRoutesGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageRoutesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageRoutesGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoverageRoutesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all stop areas
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageStopAreasGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StopAreasResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageStopAreasGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoverageStopAreasGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all stop points
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageStopPointsGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageStopPointsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageStopPointsGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoverageStopPointsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of vehicle journeys. Can be filtered by headsign, since/until dates, and data_freshness.
         * @summary List vehicle journeys
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} [headsign] Filter by headsign
         * @param {string} [since] Filter journeys since this datetime (YYYYMMDDTHHmmss)
         * @param {string} [until] Filter journeys until this datetime (YYYYMMDDTHHmmss)
         * @param {CoverageCoverageVehicleJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness filter
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageVehicleJourneysGet(coverage: string, headsign?: string, since?: string, until?: string, dataFreshness?: CoverageCoverageVehicleJourneysGetDataFreshnessEnum, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleJourneysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageVehicleJourneysGet(coverage, headsign, since, until, dataFreshness, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoverageVehicleJourneysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get vehicle journey details
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Vehicle journey ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageVehicleJourneysIdGet(coverage: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleJourneysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageVehicleJourneysIdGet(coverage, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicTransportObjectsApi.coverageCoverageVehicleJourneysIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicTransportObjectsApi - factory interface
 */
export const PublicTransportObjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicTransportObjectsApiFp(configuration)
    return {
        /**
         * 
         * @summary List all companies
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCompaniesGet(coverage: string, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesResponse> {
            return localVarFp.coverageCoverageCompaniesGet(coverage, depth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all lines
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageLinesGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<LinesResponse> {
            return localVarFp.coverageCoverageLinesGet(coverage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all networks
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageNetworksGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageNetworksGet200Response> {
            return localVarFp.coverageCoverageNetworksGet(coverage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Autocomplete on Public Transport objects
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} q Search query
         * @param {number} [count] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePtObjectsGet(coverage: string, q: string, count?: number, options?: RawAxiosRequestConfig): AxiosPromise<PlacesResponse> {
            return localVarFp.coverageCoveragePtObjectsGet(coverage, q, count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all routes
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageRoutesGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageRoutesGet200Response> {
            return localVarFp.coverageCoverageRoutesGet(coverage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all stop areas
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopAreasGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<StopAreasResponse> {
            return localVarFp.coverageCoverageStopAreasGet(coverage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all stop points
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopPointsGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageStopPointsGet200Response> {
            return localVarFp.coverageCoverageStopPointsGet(coverage, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of vehicle journeys. Can be filtered by headsign, since/until dates, and data_freshness.
         * @summary List vehicle journeys
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} [headsign] Filter by headsign
         * @param {string} [since] Filter journeys since this datetime (YYYYMMDDTHHmmss)
         * @param {string} [until] Filter journeys until this datetime (YYYYMMDDTHHmmss)
         * @param {CoverageCoverageVehicleJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness filter
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageVehicleJourneysGet(coverage: string, headsign?: string, since?: string, until?: string, dataFreshness?: CoverageCoverageVehicleJourneysGetDataFreshnessEnum, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<VehicleJourneysResponse> {
            return localVarFp.coverageCoverageVehicleJourneysGet(coverage, headsign, since, until, dataFreshness, depth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get vehicle journey details
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Vehicle journey ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageVehicleJourneysIdGet(coverage: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<VehicleJourneysResponse> {
            return localVarFp.coverageCoverageVehicleJourneysIdGet(coverage, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicTransportObjectsApi - interface
 */
export interface PublicTransportObjectsApiInterface {
    /**
     * 
     * @summary List all companies
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageCompaniesGet(coverage: string, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesResponse>;

    /**
     * 
     * @summary List all lines
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageLinesGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<LinesResponse>;

    /**
     * 
     * @summary List all networks
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageNetworksGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageNetworksGet200Response>;

    /**
     * 
     * @summary Autocomplete on Public Transport objects
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} q Search query
     * @param {number} [count] Number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoveragePtObjectsGet(coverage: string, q: string, count?: number, options?: RawAxiosRequestConfig): AxiosPromise<PlacesResponse>;

    /**
     * 
     * @summary List all routes
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageRoutesGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageRoutesGet200Response>;

    /**
     * 
     * @summary List all stop areas
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageStopAreasGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<StopAreasResponse>;

    /**
     * 
     * @summary List all stop points
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageStopPointsGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageStopPointsGet200Response>;

    /**
     * Get a list of vehicle journeys. Can be filtered by headsign, since/until dates, and data_freshness.
     * @summary List vehicle journeys
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} [headsign] Filter by headsign
     * @param {string} [since] Filter journeys since this datetime (YYYYMMDDTHHmmss)
     * @param {string} [until] Filter journeys until this datetime (YYYYMMDDTHHmmss)
     * @param {CoverageCoverageVehicleJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness filter
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageVehicleJourneysGet(coverage: string, headsign?: string, since?: string, until?: string, dataFreshness?: CoverageCoverageVehicleJourneysGetDataFreshnessEnum, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<VehicleJourneysResponse>;

    /**
     * 
     * @summary Get vehicle journey details
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id Vehicle journey ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageVehicleJourneysIdGet(coverage: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<VehicleJourneysResponse>;

}

/**
 * PublicTransportObjectsApi - object-oriented interface
 */
export class PublicTransportObjectsApi extends BaseAPI implements PublicTransportObjectsApiInterface {
    /**
     * 
     * @summary List all companies
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageCompaniesGet(coverage: string, depth?: number, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoverageCompaniesGet(coverage, depth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all lines
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageLinesGet(coverage: string, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoverageLinesGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all networks
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageNetworksGet(coverage: string, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoverageNetworksGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Autocomplete on Public Transport objects
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} q Search query
     * @param {number} [count] Number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoveragePtObjectsGet(coverage: string, q: string, count?: number, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoveragePtObjectsGet(coverage, q, count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all routes
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageRoutesGet(coverage: string, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoverageRoutesGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all stop areas
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageStopAreasGet(coverage: string, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoverageStopAreasGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all stop points
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageStopPointsGet(coverage: string, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoverageStopPointsGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of vehicle journeys. Can be filtered by headsign, since/until dates, and data_freshness.
     * @summary List vehicle journeys
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} [headsign] Filter by headsign
     * @param {string} [since] Filter journeys since this datetime (YYYYMMDDTHHmmss)
     * @param {string} [until] Filter journeys until this datetime (YYYYMMDDTHHmmss)
     * @param {CoverageCoverageVehicleJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness filter
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageVehicleJourneysGet(coverage: string, headsign?: string, since?: string, until?: string, dataFreshness?: CoverageCoverageVehicleJourneysGetDataFreshnessEnum, depth?: number, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoverageVehicleJourneysGet(coverage, headsign, since, until, dataFreshness, depth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get vehicle journey details
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id Vehicle journey ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageVehicleJourneysIdGet(coverage: string, id: string, options?: RawAxiosRequestConfig) {
        return PublicTransportObjectsApiFp(this.configuration).coverageCoverageVehicleJourneysIdGet(coverage, id, options).then((request) => request(this.axios, this.basePath));
    }
}

export const CoverageCoverageVehicleJourneysGetDataFreshnessEnum = {
    BaseSchedule: 'base_schedule',
    Realtime: 'realtime'
} as const;
export type CoverageCoverageVehicleJourneysGetDataFreshnessEnum = typeof CoverageCoverageVehicleJourneysGetDataFreshnessEnum[keyof typeof CoverageCoverageVehicleJourneysGetDataFreshnessEnum];
